import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { pdf, Page, Text, View, Document, StyleSheet , Image} from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import "./PaymentSuccess.css";
import { color } from "framer-motion";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const receiptRef = useRef();



  // Fonction utilitaire pour formatter le montant
const formatAmount = (rawAmount) => {
  // SATIM renvoie probablement en centimes (ex: 1200000 = 12000.00 DZD)
  const amountInDZD = parseFloat(rawAmount) / 100; 
  return amountInDZD.toFixed(2) + " DA";
};


  const searchParams = new URLSearchParams(location.search);

  const  actionCodeDescription = searchParams.get("actionCodeDescription") || "Paiement accepté";
 const rawAmount = searchParams.get("amount") || "0";
const amount = formatAmount(rawAmount);
  const orderId = searchParams.get("orderId") || "N/A";
  const orderNumber = searchParams.get("orderNumber") || "N/A";
  const approvalCode = searchParams.get("approvalCode") || "N/A";
  const date = searchParams.get("date") || new Date().toLocaleDateString();
  const time = searchParams.get("time") || new Date().toLocaleTimeString();
  const paymentMode = "CIB/EDAHHABIA";

  const [reservationStatus, setReservationStatus] = useState(
    "Enregistrement de la réservation..."
  );
const [createdReservation, setCreatedReservation] = useState(null);

  // 📌 Création de la réservation après paiement
useEffect(() => {
  const reservationData = JSON.parse(localStorage.getItem("reservationData"));
  const clientData = JSON.parse(localStorage.getItem("clientData"));

  if (!reservationData || !clientData) return;

  const handleWorkflowAfterReservation = async () => {
    try {
      // 1️⃣ Créer la réservation
      const resReservation = await fetch(`${process.env.REACT_APP_API_URL}/api/reservations/createReservation`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(reservationData),
      });

      if (!resReservation.ok) {
        console.error("Erreur création réservation");
        return;
      }

      const { reservation } = await resReservation.json();
      setCreatedReservation(reservation);
      setReservationStatus("✅ Réservation enregistrée avec succès !");

      // 2️⃣ Créer ou récupérer le client
      const resClient = await fetch(`${process.env.REACT_APP_API_URL}/api/client/createOrGetClient`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(clientData),
      });
      const client = await resClient.json();

      // 3️⃣ Activer le compte automatiquement
      const resActivate = await fetch(`${process.env.REACT_APP_API_URL}/api/client/activate/${client.activationToken}`);
      const activateData = await resActivate.json();

      // 4️⃣ Stocker le token JWT
      localStorage.setItem("token", activateData.token);

      // 5️⃣ Si nécessaire, mettre à jour la réservation avec le client connecté
      await fetch(`${process.env.REACT_APP_API_URL}/api/reservations/associateClient`, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          "Authorization": `Bearer ${activateData.token}`
        },
        body: JSON.stringify({ reservationId: reservation._id, clientId: client._id }),
      });

      console.log("Workflow client après paiement terminé ✅");
    } catch (err) {
      console.error("Erreur workflow après réservation :", err);
      setReservationStatus("❌ Erreur lors du workflow client.");
    }
  };

  handleWorkflowAfterReservation();
}, []);




  // 📌 Impression
  const handlePrint = () => {
    window.print();
  };



// 📌 Génération PDF (⚡ avec react-pdf)
// 📌 1. Fonction qui génère le PDF (Document React-PDF)
const generateReceiptPDF = () => {
  const styles = StyleSheet.create({
    page: {
      padding: 40,
      fontSize: 12,
      backgroundColor: "#f9f9f9", // gris clair
      fontFamily: "Helvetica",
    },
    header: {
      marginBottom: 20,
      textAlign: "center",
      borderBottom: "2px solid #1a237e", // bleu foncé
      paddingBottom: 10,
    },
    title: {
      fontSize: 22,
      fontWeight: "bold",
      color: "#1a237e",
    },
    topSection: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginBottom: 20,
    },
    hotelInfo: {
      width: "48%",
      padding: 10,
      backgroundColor: "#fff",
      border: "1px solid #ddd",
      borderRadius: 6,
    },
    clientInfo: {
      width: "48%",
      padding: 10,
      backgroundColor: "#fff",
      border: "1px solid #ddd",
      borderRadius: 6,
    },
    logo: {
      width: 80,
      height: 80,
      marginBottom: 10,
    },
    section: {
      marginBottom: 20,
      padding: 15,
      backgroundColor: "#fff",
      border: "1px solid #ddd",
      borderRadius: 6,
    },
    sectionTitle: {
      fontSize: 16,
      fontWeight: "bold",
      color: "#2e7d32", // vert élégant
      marginBottom: 10,
      textAlign: "center",
    },
    row: {
      marginBottom: 6,
    },
    label: {
      fontWeight: "bold",
      color: "#1565c0",
    },
    value: {
      color: "#000",
    },
    footer: {
      marginTop: 30,
      textAlign: "center",
      fontSize: 10,
      color: "gray",
      borderTop: "1px solid #ddd",
      paddingTop: 10,
    },
  });

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* ✅ En-tête */}
        <View style={styles.header}>
          <Text style={styles.title}>Reçu de paiement</Text>
        </View>

        {/* ✅ Haut de page : hôtel (gauche) / client (droite) */}
        <View style={styles.topSection}>
          {/* Bloc Hôtel */}
          <View style={styles.hotelInfo}>
            <Image src="/logo.jpg" style={styles.logo} />
            <Text style={styles.label}>Hôtel Syphax</Text>
            <Text style={styles.value}>Adresse : Route Nationale N 09-Tichy-Bejaia</Text>
            <Text style={styles.value}>Email : hotelsyphax1@gmail.com</Text>
            <Text style={styles.value}>Tél :  034.81.67.04</Text>
          </View>

          {/* Bloc Client */}
          <View style={styles.clientInfo}>
            <Text style={styles.label}>Informations Client</Text>
            <Text style={styles.value}>
              Nom : {createdReservation?.client?.nom || "N/A"}{" "}
              {createdReservation?.client?.prenom || ""}
            </Text>
            <Text style={styles.value}>
              Email : {createdReservation?.client?.email || "N/A"}
            </Text>
            <Text style={styles.value}>
              Téléphone : {createdReservation?.client?.telephone || "N/A"}
            </Text>
          </View>
        </View>

        {/* ✅ Détails du paiement */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Détails du paiement</Text>
          <Text><Text style={styles.label}>Statut : </Text>{ actionCodeDescription}</Text>
          <Text><Text style={styles.label}>Montant : </Text>{amount} </Text>
          <Text><Text style={styles.label}>Identifiant de transaction : </Text>{orderId}</Text>
          <Text><Text style={styles.label}>Numéro de commande : </Text>{orderNumber}</Text>
          <Text><Text style={styles.label}>Code d'autorisation : </Text>{approvalCode}</Text>
          <Text><Text style={styles.label}>Date/Heure : </Text>{date} {time}</Text>
          <Text><Text style={styles.label}>Mode de paiement : </Text>{paymentMode}</Text>
          <Text>En cas de problème de paiement, veuillez contacter SATIM : 3020</Text>
        </View>

        {/* ✅ Informations Réservation */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Informations de la réservation</Text>
          <Text><Text style={styles.label}>Réservation N° : </Text>{createdReservation?._id || "N/A"}</Text>
          <Text><Text style={styles.label}>Chambre : </Text>{createdReservation?.id_chambre || "N/A"}</Text>
          <Text><Text style={styles.label}>Date d'entrée : </Text>
            {createdReservation?.date_entree ? new Date(createdReservation.date_entree).toLocaleDateString("fr-FR") : "N/A"}
          </Text>
          <Text><Text style={styles.label}>Date de sortie : </Text>
            {createdReservation?.date_sortie ? new Date(createdReservation.date_sortie).toLocaleDateString("fr-FR") : "N/A"}
          </Text>
          <Text><Text style={styles.label}>Adultes : </Text>{createdReservation?.nombre_adultes ?? "N/A"}</Text>
          <Text><Text style={styles.label}>Enfants : </Text>{createdReservation?.nombre_enfants ?? "N/A"}</Text>
        </View>

        {/* ✅ Pied de page */}
        <Text style={styles.footer}>
          — Hôtel Syphax • www.hotelsyphax.com
        </Text>
      </Page>
    </Document>
  );
};

// 📌 2. Télécharger le PDF
const handleDownloadPDF = async () => {
  const blob = await pdf(generateReceiptPDF()).toBlob();
  saveAs(blob, `Reçu_Paiement_${orderNumber}.pdf`);
};

// 📌 3. Envoyer par e-mail
const handleSendEmail = async () => {
  if (!createdReservation) {
    alert("❌ Réservation introuvable.");
    return;
  }

  try {
    const blob = await pdf(generateReceiptPDF()).toBlob();

    const formData = new FormData();
    formData.append("pdf", blob, `Reçu_Paiement_${orderNumber}.pdf`);
    formData.append("email", createdReservation.client.email);

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/paiement/send-Receipt`,
      { method: "POST", body: formData }
    );

    if (response.ok) {
      alert("📧 Reçu envoyé par e-mail !");
    } else {
      const err = await response.json();
      alert("❌ Erreur : " + err.message);
    }
  } catch (error) {
    console.error(error);
    alert("❌ Erreur serveur.");
  }
};


  const handleReturn = () => {
    navigate("/");
  };


  return (
    <div className="success-container">
      <div className="success-card" ref={receiptRef}>
        <h2>✅ Paiement réussi</h2>
        <p>
          <strong>{actionCodeDescription}</strong>
        </p>
        <p>
          <strong>Montant :</strong> {amount}
        </p>
        <p>
          <strong>Réservation :</strong> {reservationStatus}
        </p>
        <hr />
        <p>
          <strong>Identifiant de la transaction:</strong> {orderId}
        </p>
        <p>
          <strong>Numéro de commande (orderNumber):</strong> {orderNumber}
        </p>
        <p>
          <strong>Code d'autorisation:</strong> {approvalCode}
        </p>
        <p>
          <strong>Date/Heure :</strong> {date} {time}
        </p>
        <p>
          <strong>Mode de paiement :</strong> {paymentMode}
        </p>
        <p>
          📞 Assistance SATIM : <strong>3020</strong>
        </p>
      </div>

      
    
    <div className="success-actions">
        <button onClick={handlePrint}>🖨️ Imprimer</button>
        <button onClick={handleDownloadPDF}>⬇️ Télécharger PDF</button>
        <button onClick={handleSendEmail}>📧 Envoyer par e-mail</button>
        <button onClick={handleReturn}>🏠 Retour à l'accueil</button>
      </div>
      </div>
  );
};

export default PaymentSuccess;
